import React, { Component } from "react";
import { connect } from "react-redux";
import { Spin } from "antd";
import ListMouvements from "../../components/ListMouvements";
import { columns } from "./columns";
import { loadLocations } from "../../store/actions/locationAction";
import { loadQuittances } from "../../store/actions/quittanceAction";
import { loadReglements } from "../../store/actions/reglementAction";
import { loadTypesLots } from "../../store/actions/typeLotAction";
import { loadImmeubles } from "../../store/actions/immeubleAction";
import { loadRubriques } from "../../store/actions/rubriqueAction";

class Mouvements extends Component {
  componentDidMount() {
    this.props.loadLocations();
    this.props.loadQuittances();
    this.props.loadReglements();
    this.props.loadTypesLots();
    this.props.loadImmeubles();
    this.props.loadRubriques();
  }

  render() {
    const { locations, quittances, reglements, typesLots, immeubles, rubriques } =
      this.props;

    return (
      <Spin spinning={!locations && !quittances} size="large" tip="Chargement en cours...">
        <ListMouvements
          locations={
            locations && locations.sort((a, b) => a.location_id - b.location_id)
          }
          quittances={quittances}
          reglements={reglements}
          tableOption={columns}
          typesLots={typesLots}
          immeubles={immeubles}
          rubriques={rubriques}
        ></ListMouvements>
      </Spin>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadLocations: () => dispatch(loadLocations()),
    loadQuittances: () => dispatch(loadQuittances()),
    loadReglements: () => dispatch(loadReglements()),
    loadTypesLots: () => dispatch(loadTypesLots()),
    loadImmeubles: () => dispatch(loadImmeubles()),
    loadRubriques: () => dispatch(loadRubriques()),
  };
};

// mapper le state aux props du component
const mapStateToProps = (state) => {
  return {
    utilisateur: state.utilisateur.data,
    locations: state.locations.data,
    quittances: state.quittances.data,
    reglements: state.reglements.data,
    typesLots: state.typesLots.data,
    immeubles: state.immeubles.data,
    rubriques: state.rubriques.data,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Mouvements);
